import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, authStatus, roleCheck }) {
  if (authStatus === null) return <div>Loading...</div>;
  if (!authStatus) return <Navigate to="/" replace />;
  if (roleCheck === false) return <Navigate to="/dashboard" replace />;

  return <>{children}</>;
}
